__turbopack_context__.v({
  "accordionContent": "accordion-module-scss-module__sxg8OW__accordionContent",
  "accordionContentInner": "accordion-module-scss-module__sxg8OW__accordionContentInner",
  "accordionItem": "accordion-module-scss-module__sxg8OW__accordionItem",
  "accordionTrigger": "accordion-module-scss-module__sxg8OW__accordionTrigger",
  "icon": "accordion-module-scss-module__sxg8OW__icon",
  "open": "accordion-module-scss-module__sxg8OW__open",
});
